import type {EmptyPayload} from 'constants/events/EventPayloadUtils';
import type {TFIAccount, TFIFolderServerResponse} from 'notebook/tfi/TFIConstants';

export const TFI_EVENT_PAYLOADS = {
  TFI_ACCOUNT_ADDED: {} as {account: TFIAccount},
  TFI_ACCOUNT_DELETED: {} as {accountId: string},
  TFI_ACCOUNTS_FETCHED: {} as {accounts: Array<TFIAccount>},
  TFI_FOLDER_LISTED: {} as {folderId: string},
  TFI_FOLDER_CONTENTS_FETCHED: {} as {
    folderId: string;
    tfiObjects: TFIFolderServerResponse['results'];
  },
  TFI_FILE_IMPORTED: {} as EmptyPayload,
  TFI_FILE_META_CHECK_FOR_UPDATES: {} as {tfiFileMetaId: number},
  TFI_FILE_META_CHECK_FOR_UPDATES_COMPLETED: {} as {tfiFileMetaId: number},
  TFI_FILE_META_REGISTER_CHECK_FOR_UPDATES: {} as {tfiFileMetaId: number},
  TFI_FILE_META_DEREGISTER_CHECK_FOR_UPDATES: {} as {tfiFileMetaId: number},
  TFI_SYNC_STARTED: {} as EmptyPayload,
  TFI_FILE_METAS_REFRESHED: {} as EmptyPayload,
  TFI_BULK_REGISTER_REMOTE_REVISION_ID: {} as {
    thirdpartyFileRevsByTFIMetaId: Record<number, string | null | undefined>;
  },
  TFI_TOGGLE_ADD_MODAL: {} as {show: boolean},
  TFI_LIST_ACCOUNTS: {} as EmptyPayload,
  TFI_SEARCH_SET_QUERY: {} as {query: string},
  TFI_SEARCH_SET_TFI_ACCOUNT_FILTER: {} as {tfiAccountFilter: string | null},
  TFI_SEARCH_CLEAR_SEARCH: {} as EmptyPayload,
} as const;

export type TFIEventPayload = typeof TFI_EVENT_PAYLOADS;
